/* Inline form validation (newsletter, contact). Add data-pc-validate to a <form>.
   Every required/email field needs an error element: <p class="pc-field__error" id="<field id>-err"></p>
   and aria-describedby pointing to it. No server round trip, no browser bubbles. */
(function () {
  if (window.pcForms) return; window.pcForms = true;

  function message(input) {
    var v = input.validity;
    if (v.valueMissing) return input.getAttribute('data-msg-required') || (input.type === 'email' ? 'Please enter your email address.' : 'Please fill in this field.');
    if (v.typeMismatch || v.patternMismatch) return input.type === 'email' ? 'That email address does not look right. Example: name@example.com' : 'Please check this field.';
    if (v.tooShort) return 'Please write a little more.';
    return input.validationMessage || 'Please check this field.';
  }

  function check(input) {
    var err = document.getElementById(input.id + '-err');
    var ok = input.checkValidity();
    input.setAttribute('aria-invalid', ok ? 'false' : 'true');
    if (err) err.textContent = ok ? '' : message(input);
    return ok;
  }

  document.querySelectorAll('form[data-pc-validate]').forEach(function (form) {
    form.setAttribute('novalidate', '');
    var fields = [].slice.call(form.querySelectorAll('input[required], textarea[required], input[type=email]'));
    var touched = false;
    fields.forEach(function (f) {
      f.addEventListener('blur', function () { if (touched || f.value) check(f); });
      f.addEventListener('input', function () { if (f.getAttribute('aria-invalid') === 'true') check(f); });
    });
    form.addEventListener('submit', function (e) {
      touched = true;
      var bad = fields.filter(function (f) { return !check(f); });
      if (bad.length) { e.preventDefault(); bad[0].focus(); }
    });
  });
})();
